import nodeWaves from 'node-waves/src/js/waves';

export { nodeWaves };
